/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetData } from '../../../../../hooks/useWidgetState'
import { usePageConfigUser } from '../../../../../hooks/usePageConfig'
import ErrorMessage from '../../../../share/ErrorMessage'
import { getProvisionedInsightDataSet } from '../utils'

const SourceDonutEmptyResultGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const pageConfigUser = usePageConfigUser()
  const { t } = useTranslation()

  const entries = getProvisionedInsightDataSet(widgetData, pageConfigUser)
  const sum = entries.map((entry) => entry.value!).reduce((acc, curr) => acc + curr, 0)

  if (!sum) return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>

  return children
}

export default SourceDonutEmptyResultGuard
